var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendTop = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 13.47-4.073 4.057a.74.74 0 0 1-.514.22.7.7 0 0 1-.54-.22.72.72 0 0 1-.217-.527q0-.31.217-.527l4.494-4.494a.83.83 0 0 1 .633-.256.83.83 0 0 1 .633.256l4.494 4.494q.208.208.22.515a.7.7 0 0 1-.22.539.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217L12 13.469Zm0-6-4.073 4.057a.74.74 0 0 1-.514.22.7.7 0 0 1-.54-.22.72.72 0 0 1-.217-.527q0-.31.217-.527l4.494-4.494A.83.83 0 0 1 12 5.723a.83.83 0 0 1 .633.256l4.494 4.494q.208.207.22.514a.7.7 0 0 1-.22.54.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendTop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send-top.26aa6d05.svg";